import React, { useEffect } from 'react';
import './AboutUs.css'; // Custom styles for enhanced design
import 'font-awesome/css/font-awesome.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from 'react-i18next'; // Import useTranslation
const AboutUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  const { t } = useTranslation(); // Get the t function
  return (
    <div className="about-us">
      {/* Header Section */}
      <header
        className="about-us-header text-center py-5 text-white"
        style={{
          background: 'linear-gradient(135deg, #2a3d66, rgb(6, 41, 52))',
        }}
        data-aos="fade-down"
      >
        <div className="container">
          <h1 className="fw-bold mb-4 display-3 text-shadow">About Ag Pipe Fitting Technology</h1>
          <p className="lead mb-4 fs-4">
            Innovating pipe fitting solutions that enhance infrastructure and drive operational efficiency.
          </p>
        </div>
      </header>

      {/* Mission and Vision Section */}
      <section className="py-5" style={{ backgroundColor: '#f1f1f1' }}>
        <div className="container">
          <h2 className="text-center text-primary fw-bold mb-5" data-aos="zoom-in">
          
          
          </h2>
          <div className="row g-4">
            <div className="col-lg-6" data-aos="fade-right">
              <div className="card shadow-sm border-0 rounded-4">
                <div className="card-body p-4">
                <h4 className="display-4 fw-bold mb-3 text-primary" data-aos="fade-up">{t('Mission')}</h4>
                  
                <p className="text-muted fs-5" data-aos="fade-up" data-aos-delay="600" dangerouslySetInnerHTML={{ __html: t('mission1') }} />
                </div>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <div className="card shadow-sm border-0 rounded-4">
                <div className="card-body p-4">
                <h4 className="display-4 fw-bold mb-3 text-primary" data-aos="fade-up">{t('Vission')}</h4>
                <p className="text-muted fs-5" data-aos="fade-up" data-aos-delay="600" dangerouslySetInnerHTML={{ __html: t('Vission1') }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Delivery System Section */}
      <section className="py-5" style={{ backgroundColor: '#e1f5fe' }}>
  <div className="container">
    <h6 className="display-4 fw-bold mb-3 text-primary" data-aos="fade-up">{t('Delivery')}</h6>
    <div className="row g-4">
      <div className="col-lg-6 d-flex align-items-center" data-aos="fade-up" data-aos-delay="600">
        {/* Delivery Text */}
        <p className="text-muted fs-5" dangerouslySetInnerHTML={{ __html: t('Deliveries') }} />
      </div>
      <div className="col-lg-6 d-flex align-items-center" data-aos="zoom-in">
        {/* Image */}
        <img
          src="/images/1w.png"  // Add your relevant image path here
          alt="Product Delivery"
          className="img-fluid"
          style={{ maxHeight: '300px' }}
        />
      </div>
    </div>
  </div>
</section>


     

      {/* Our Products Section */}
      <section className="py-5" style={{ backgroundColor: '#ffffff' }}>
        <div className="container">
          <h2 className="text-center text-primary fw-bold mb-5" data-aos="flip-up">Our Products</h2>
          <div className="row g-4">
            {[ 
              { title: 'Hdpe Injection Fittings', image: '/images/hdpe.PNG' },
              { title: 'Hdpe Fabricated Butt Weld Fittings', image: '/images/xxx.PNG' },
              { title: 'PPR Fittings', image: '/images/PPR.jpg.PNG' },
              { title: 'Upvc Fittings', image: '/images/yyy.PNG' },
              { title: 'Jerrycans', image: '/images/jery.PNG' },
              { title: 'Paint Buckets', image: '/images/paint.PNG' },
              { title: 'Fiber Products', image: '/images/fiber.PNG' },
              { title: 'Stadium Seat', image: '/images/eee.PNG' },
            ].map((product, index) => (
              <div key={index} className="col-lg-3 col-md-4 col-sm-6" data-aos="zoom-in">
                <div className="card shadow-sm border-0 rounded-4 h-100 overflow-hidden product-card">
                  <img 
                    src={product.image} 
                    alt={product.title}
                    className="card-img-top product-image"
                    style={{ height: '200px', width: '300px' }}
                  />
                  <div className="card-body text-center p-3">
                    <h5 className="fw-bold mb-0">{product.title}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="py-5" style={{ backgroundColor: '#e1f5fe' }}>
        <div className="container">
        <h6 className="display-4 fw-bold mb-3 text-primary text-center" data-aos="fade-up">{t('coreValues')}</h6>
          <div className="row g-4 text-center">
            {[ 
              { icon: 'fas fa-smile', title: t('satisfyingCustomers'), color: '#8e24aa' },
              { icon: 'fas fa-certificate', title: t('productQuality'), color: '#f44336' },
              { icon: 'fas fa-heart', title: t('socialWelfare'), color: '#4caf50' },
              { icon: 'fas fa-dollar-sign', title: t('costEffectiveness'), color: '#ff5722' },
              { icon: 'fas fa-flag-checkered', title: t('commitmentOwnership'), color: '#00796b' },
              { icon: 'fas fa-tools', title: t('changePrinciples'), color: '#9c27b0' },
            ].map((value, index) => (
              <div key={index} className="col-lg-4 col-md-6" data-aos="flip-left">
                <div className="card shadow-sm border-0 rounded-4 py-5 h-100">
                  <i className={`${value.icon} fa-3x mb-4`} style={{ color: value.color }}></i>
                  <h5 className="fw-bold mb-3">{value.title}</h5>
                  
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
